window.VerifyPdf = require('./signature_checker');
